import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import LetterOrderProgress from "../../parts/LetterOrderProgress";
import DownloadButtonsComponent from "../../../OrderList/parts/DownloadButtons"; // 外部ルートのディレクトリのインポートのため、Component末尾に付与している
import { addCommas } from "../../../../utils/utils";
import { isDisplayFollowCallExist } from "../../../../utils/orderUtils";

const styles = () => ({
  root: {
    background: "#F2F6FF",
    padding: "20px",
  },

  count: {
    color: "#195AFF",
    fontSize: "20px",
  },

  call: {
    color: "#71737B",
    background: "#FFFFFF",
    display: "inline-block",
    padding: "5px",
    fontSize: "11px",
    margin: "5px 0",
    fontWeight: "bold",
  },

  text: {
    color: "#195AFF",
    fontSize: "11px",
  },

  btns: {
    marginTop: "10px",
    display: "flex",
    gap: "10px",
    alignItems: "end",
  },

  btn: {
    padding: "10px 18px",
    height: "33px",
    borderRadius: "2px",
    fontSize: "13px",
  },

  btnDisable: {
    border: "1px solid #ECEDEF",
    background: "#ECEDEF",
    color: "#000000",
  },

  btnEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: "#FFFFFF",
    },
  },
});

class LetterOrderAttribute extends React.Component {
  render() {
    const { classes, order, user } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.text}>{"No." + order.letter_order.id}</div>
        <div className={classes.count}>
          {addCommas(order.letter_order.order_addresses_count) + "通"}
        </div>
        {isDisplayFollowCallExist(order, user) && (
          <div className={classes.call} style={order.follow_call_order ? { color: '#FFFFFF', background: '#195AFF' } : {}}>
            <span>
              {"フォローコール" + (order.follow_call_order ? "あり" : "なし")}
            </span>
          </div>
        )}
        <LetterOrderProgress
          status={order.letter_order.latest_timeline_status}
        />
        <div className={classes.text}>
          {order.letter_order.order_contact.name +
            "さんがキーマンデータベースから注文"}
        </div>
        <div className={classes.text}>
          {order.letter_order.shinten_mark_flag
            ? "親展マーク有り"
            : "親展マーク無し"}
        </div>
        <div className={classes.text}>
          {order.letter_order.registered_letter_flag
            ? "書留利用"
            : "書留利用なし"}
        </div>
        <div className={classes.text}>
          {(order.letter_order.sender_company || "") +
            (order.letter_order.sender_branch || "") +
            (order.letter_order.sender_position || "") +
            (order.letter_order.sender_name || "")}
        </div>
        <div className={classes.text}>
          {order.letter_order.original_letter_format_flag
            ? "別途納品したレターフォーマットを利用"
            : "キーマンレターのレターフォーマットを利用"}
        </div>
        <div className={classes.btns}>
          {/* // DLボタンなどを表示 */}
          <DownloadButtonsComponent
            item={order.letter_order}
            isAnchorTag={false}
          />
        </div>
      </div>
    );
  }
}

LetterOrderAttribute.propTypes = {
  classes: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  user: PropTypes.object,
};

export default withStyles(styles)(LetterOrderAttribute);



// WEBPACK FOOTER //
// ./src/components/Timeline/dialogs/parts/LetterOrderAttribute.jsx